import React from "react";
import "../CallToActionBanner.css";

const CallToActionBanner = ({ setActivePage, setActiveTab }) => {

  const handleStartLearning = () => {
    setActivePage("Video Tutorials"); // Activate header link
    setActiveTab("video"); // Activate tab
    const section = document.getElementById("video-tutorials-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="cta-banner">
      <div className="cta-overlay"></div> {/* Overlay */}
      <div className="cta-content">
        <h2>Join Our Learning Community​</h2>
        <p>
          Experience the future of learning today. Sign up now and take the first
          step towards an empowered educational journey!
        </p>
        <button className="cta-btn" onClick={handleStartLearning}>
          Start Learning Now
        </button>
      </div>
    </section>
  );
};

export default CallToActionBanner;
